module.exports = __webpack_public_path__ + "static/media/teygja_innanverdlaeri_a.f6b20338.png";